<!-- ----------------------------------------------- -->
<template>
  <v-sheet tile class="com-pc-card tm-mb-no-shadow" :height="height">
    <v-row ref="damDiagWrapper" no-gutters>
      <div>
        <div
          id="content-dam-diag"
          :width="damDiagWidth"
          :height="damDiagHeight"
          v-html="getDamDiag"
          class="ma-1"
        />
      </div>
    </v-row>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]ダム 模式図カード
 * TmDamDiag.vue
 * @author ILUKE
 */

import libDamDiag from "../../lib/DamDiag";

export default {
  name: "tm-dam-diag",
  props: {
    /** 親要素の幅 */
    width: {
      type: Number,
      default: 10,
    },
    /** 親要素の高さ */
    height: {
      type: Number,
      default: 150,
    },
    /** 時間/10分指定 */
    isHour: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLimit: false,
      isSpare: false,
      stageLimit: 290,
      stageSpare: 280,
      damDiagHeight: null,
      damDiagWidth: null,
    };
  },
  created() {
    this.damDiagWidth = this.width;
    this.damDiagHeight = this.height;

    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    /** 水位表示 */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 水位表示切替メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /**
     * 表示フラグ
     */
    dspFlg: {
      get() {
        return this.$store.state.Telemeter.selectedTm.tmDamDetailInfo.dwDspFlg;
      },
    },
    dam: {
      get() {
        let diag = this.$store.state.Telemeter.selectedTm.diag;
        if (diag == null) {
          return null;
        }
        let info = diag.dam;

        // 下流水位観測所が存在する場合
        if (info.spec.stage != null) {
          if (this.stgMode === "1" && this.dspFlg === 1) {
            // 堤防天端から
            info.spec.stage.label = this.stgMsg.topendStg;
            info.value.stage.lvl = info.value.stage.lvlHght;
            info.value.stageH.lvl = info.value.stageH.lvlHght;
          } else {
            // 零点高から
            info.spec.stage.label = this.stgMsg.normalStg;
          }
        }

        let dam = {
          value: {
            date: info.value.date,
            time: info.value.time,
            dam: null,
            rain: {
              rain: null,
              rainCcd: null,
              cautOvflg: null,
              warnOvflg: null,
              total: info.value.rain.total,
              totalCcd: info.value.rain.totalCcd,
              totalCautOvflg: info.value.rain.totalCautOvflg,
              totalWarnOvflg: info.value.rain.totalWarnOvflg,
            },
            stage: null,
          },
          dsch: info.dsch,
          spec: {
            dam: info.spec.dam,
            rain: info.spec.rain,
            stage: info.spec.stage,
          },
        };

        // 10分雨量・累積雨量
        if (this.isHour) {
          dam.value.rain.rain = info.value.rain.rainH;
          dam.value.rain.rainCcd = info.value.rain.rainHCcd;
          dam.value.rain.cautOvflg = info.value.rain.rainHCautOvflg;
          dam.value.rain.warnOvflg = info.value.rain.rainHWarnOvflg;
          dam.value.dam = info.value.damH;
          dam.value.stage = info.value.stageH;
        } else {
          dam.value.rain.rain = info.value.rain.rainM;
          dam.value.rain.rainCcd = info.value.rain.rainMCcd;
          dam.value.rain.cautOvflg = info.value.rain.rainMCautOvflg;
          dam.value.rain.warnOvflg = info.value.rain.rainMWarnOvflg;
          dam.value.dam = info.value.dam;
          dam.value.stage = info.value.stage;
        }

        return dam;
      },
    },
    /** 描画パラメータ */
    viewProp: {
      get() {
        return {
          width: this.damDiagWidth,
          height: this.damDiagHeight,
          isHour: this.isHour,
          isFldCtl: this.$store.getters["app/isFldCtl"],
        };
      },
    },
    getDamDiag() {
      if (this.dam != null) {
        return libDamDiag.getSvgDamDiag(this.dam, this.viewProp, this.isHour);
      } else {
        return null;
      }
    },
  },
  methods: {
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.damDiagWrapper !== undefined) {
          const offsetWidth = this.$refs.damDiagWrapper.offsetWidth;
          const offsetHeight = this.$refs.damDiagWrapper.offsetHeight;
          if (offsetWidth > 0 && offsetHeight > 0) {
            this.damDiagWidth = offsetWidth - 8;
            if (offsetWidth / 2 < this.height - 10 || this.height === 10) {
              this.damDiagHeight = offsetWidth / 2;
            } else {
              this.damDiagHeight = this.height - 10;
            }
          }
        }
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
